import { PrefixId, ActionSummary } from "features/Resources/Shared/models";
import { User } from "features/User/models";
import { PersonalizationTokenRoleName } from "./personalizationToken";
import { Company } from "./company";
import { NewHireJourney } from "./v2/newHireJourney";
import { MessageServiceChannel } from "./integration/messageService";

export type IssueType =
| "missing_channel_membership"
| "missing_message_service_user"
| "missing_message_service"
| "missing_email"
| "unassigned_role"
| "missing_attribute"
| "undelivered"
| "unauthorized_message_sender"
| "deactivated_sender"
| "deactivated_recipient";

export const TIMING_ISSUE_TYPES = [
  "undelivered",
];

export type IssueId = string;

export type TimingIssueType = typeof TIMING_ISSUE_TYPES[number];

export type NonTimingIssueType = Exclude<IssueType, TimingIssueType>;

export type IssueContext = {
  roleName: PersonalizationTokenRoleName;
  attribute: string;
  emailType: string;
  userId: string;
};

export type IssueSummary = {
  id: IssueId;
  issueType: IssueType; // TODO: Replace with enum or union type
  newHireName: string;
  newHireJourneyId: string;
  actionPrefixIds: PrefixId[];
  context: IssueContext;
  createdAt? : Date;
};

export type IssueDetail = IssueSummary & {
  company?: Company;
  user?: User;
  newHireJourney?: NewHireJourney;
  actions?: ActionSummary[];
  messageServiceChannel: MessageServiceChannel;
};

export type FieldDef<T> = {
  name: keyof T
  label?: string;
};
